/**
 * [pug template]
 */
<template lang="pug">
  .zoom-in-place.zoom-component(v-if="isDisplayed", @mousemove.stop="setZoomEvent(true, $event)", @mouseleave.stop="setZoomEvent(false)", @click.stop="onClick", :style="zoomStyle")
</template>
/**
 * [javascript application]
 */
<script>
import Vue from 'vue'
import ZoomLib from '../../../lib/common/zoom'

export default {
  name: 'zoom-in-place',
  props: {
    image: {
      type: String,
      default: ''
    },
    isDisplayed: {
      type: Boolean,
      default: false
    },
    onClick: {
      type: Function,
      default: function () { }
    }
  },
  data: function () {
    return {
      zoomStyle: {}
    }
  },
  components: {},
  methods: Object.assign({}, ZoomLib, {
    /**
     * Crée le style du zoom sur place
     */
    setZoomOnItself: function () {
      Vue.set(this.zoomStyle, 'background-image', 'url("' + this.image + '")')
      Vue.set(this.zoomStyle, 'background-repeat', 'no-repeat')
      Vue.set(this.zoomStyle, 'background-size', '200%')
      Vue.set(this.zoomStyle, 'background-position', (Math.max(-this.event.original_size.x, -this.event.position.x * 2)) + 'px ' + (Math.max(-this.event.original_size.y, -this.event.position.y * 2)) + 'px')
    }
  }),
  watch: {}
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// ZoomInPlace.vue?bd5396fc